<template>
  <div class="card">
    <div class="card-body">
      <div class="row m-2">
        <div class="col-12 p-l-0 title">
          <img src="/theme/icons/events.svg" class="m-r-20">
          <span>ПОДІЇ В БІБЛІОТЕЦІ</span>
        </div>
      </div>
      <template v-if="newStory.length > 0">
        <div v-for="story in newStory" class="story-new">
          <div>
            <template v-if="story.action_id == 1 || story.action_id == 2">
              {{ story.user.name }} {{ story.action.description }} "{{ story.book ? story.book.description.title : 'ВИДАЛЕНО' }}" {{ story.reader.fullname }}
            </template>
            <template v-else-if="story.action_id == 3 || story.action_id == 4 || story.action_id == 5">
              {{ story.user.name }} {{ story.action.description }} "{{ story.book ? story.book.description.title : story.note_book }}"
            </template>
            <template v-else-if="story.action_id == 6 || story.action_id == 7 || story.action_id == 8 || story.action_id == 9 || story.action_id > 9">
              {{ story.user.name }} {{ story.action.description }} {{ story.reader ? story.reader.fullname : story.note_reader }}
            </template>
          </div>
          <div class="created text-right">
            {{ moment(story.created_at).format("YYYY-MM-DD hh:mm:ss") }}
          </div>
        </div>
      </template>

      <template v-if="stories.data.length > 0">
        <div v-for="story in stories.data" :class="story.new ? 'story-new' : 'story'">
          <div>
            <template v-if="story.action_id == 1 || story.action_id == 2">
              {{ story.user.name }} {{ story.action.description }} "{{ story.book ? story.book.description.title : 'ВИДАЛЕНО' }}" {{ story.reader.fullname }}
            </template>
            <template v-else-if="story.action_id == 3 || story.action_id == 4 || story.action_id == 5">
              {{ story.user.name }} {{ story.action.description }} "{{ story.book ? story.book.description.title : story.note_book }}"
            </template>
            <template v-else-if="story.action_id == 6 || story.action_id == 7 || story.action_id == 8 || story.action_id == 9 || story.action_id > 9">
              {{ story.user.name }} {{ story.action.description }} {{ story.reader ? story.reader.fullname : story.note_reader }}
            </template>
          </div>
          <div class="created text-right">
            {{ moment(story.created_at).format("YYYY-MM-DD hh:mm:ss") }}
          </div>
        </div>
        <div v-if="stories.last_page != stories.current_page" class="m-t-20 text-center" @click="getStories()">
          <img src="/theme/icons/more-circle.svg">
        </div>
      </template>
      <template v-else>
        <p>Поки подій немає</p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventsLibrary",
  data(){
    return {
      stories: {data:[]},
      newStory:[]
    }
  },
  mounted() {
    this.getStories();
  },
  methods:{
    getStories: function(newStory = false) {
      let url;
      if(this.stories.data.length == 0 || newStory){
        url = '/library/stories/' + this.$root.$data.userId;
      } else{
        url = this.stories.next_page_url;
      }
      if(url){
        axios.get(url)
            .then(response => {
              if(this.stories.data.length > 0) {
                let stories = this.stories.data;
                this.stories = response.data;

                if(newStory == true){
                  this.newStory = response.data.data.filter(el => {
                        return !stories.some(it => {
                          console.log(it.id, el.id);

                          return it.id == el.id
                        });
                      }
                  ).concat(this.newStory);
                } else{
                  this.stories.data = stories.concat(response.data.data);
                }

              } else{
                this.stories = response.data;
              }
            });
      }
    },
    moment: function (date) {
      return moment(date);
    },
  },
}
</script>

<style scoped>
  .created{
    color: #A7AFBA;
  }
  .story{
    border-radius: 8px;
    border: 1px solid #E5E5E5;;
    margin-top: 20px;
    padding:10px;
    font-size:14px;
    position: relative;
  }

  .story::before, .story::after {
    content: '';
    position: absolute;
    left: 20px; bottom: -10px;
    border: 5px solid transparent; border-left: 5px solid #E5E5E5; border-top: 5px solid #E5E5E5;
  }
  .story::after {
    left: 21px;
    border: 5px solid transparent; border-left: 3px solid white; border-top: 5px solid white;
  }
  .story-new{
    background: #F8F8F8;
    margin-top: 20px;
    padding:10px;
    font-size:14px;
    position: relative;
    border-radius: 8px;
  }
  .story-new::before, .story-new::after {
    content: '';
    position: absolute;
    right: 20px; bottom: -10px;
    border: 5px solid transparent; border-right: 5px solid #E5E5E5; border-top: 5px solid #E5E5E5;
  }
  .story-new::after {
    right: 21px;
    border: 5px solid transparent; border-right: 3px solid #F8F8F8; border-top: 5px solid #F8F8F8;
  }
</style>
